import { RootStateOrAny, useSelector } from "react-redux";
import React from "react";
import { useTranslation } from "react-i18next";
import OrderDetailTxt from "../../orders/components/forms/edditOrder/OrderDetailTxt";
import { divider, mainWrapper, wrapper } from "../styles/style"

const ReportReadOnlyDetails: React.FC = () => {
    const { t } = useTranslation("admin");
    const { reportDetails } = useSelector(
        (state: RootStateOrAny) => state.reports
    );
    return (
        <div className={mainWrapper}>
            <div className={wrapper}>
                <div className={divider}>
                    <OrderDetailTxt
                        title={t("nav.reportName") as string}
                        value={reportDetails ? reportDetails.name : ""}
                    />
                </div>
                <div className={divider}>
                    <OrderDetailTxt
                        title={t("nav.reportDescription") as string}
                        value={reportDetails ? reportDetails.description : ""}
                    />
                </div>
            </div>
        </div>
    );
};

export default ReportReadOnlyDetails;